import {Component, inject, input, Input, InputSignal, Signal} from '@angular/core';
import {
  LocationOfDevicesUnrelatedToRoadOccupationForm
} from '../../forms/location-of-devices-unrelated-to-road-occupation.form';
import { CommonModule, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import {
  LocationOfDevicesUnrelatedToRoadOccupationStageFormComponent
} from '../location-of-devices-unrelated-to-road-occupation-stage-form/location-of-devices-unrelated-to-road-occupation-stage-form.component';
import {
  LocationDecisionsCrudComponent
} from '../../../../../common/components/location-decisions/location-decisions-crud/location-decisions-crud.component';
import {
  StageFormComponent
} from '../../../../../common/occupation-data-section/components/stage-form/stage-form.component';
import {Store} from "@ngrx/store";
import {RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee} from "../../../../../../../../openapi";
import {selectPurposeFeeCollection} from "../../../../../../../../store/selectors/application.selectors";

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ValidationErrorsComponent,
    TabPanelComponent,
    TabViewComponent,
    LocationOfDevicesUnrelatedToRoadOccupationStageFormComponent,
    LocationDecisionsCrudComponent
  ],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-form.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationFormComponent {

  private store$: Store = inject(Store);

  public purposeFeeCollection: Signal<RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]> = this.store$.selectSignal(selectPurposeFeeCollection);

  @Input()
  public form: LocationOfDevicesUnrelatedToRoadOccupationForm | undefined;

  public serviceId: InputSignal<string | null> = input<string | null>(null);
}
